import { formatBalance } from '@/helpers/utils';
import { WELCOME_OFFER_RELEASE_DATE } from '@/store/modules/welcome';

export default {
  getSideBarState(state) {
    return state.sidebar;
  },
  loadedOrders(state) {
    return state.loadedOrders;
    // return state.loadedOrders
  },
  getuser(state) {
    return state.user;
  },
  getReferralRewardsData(state) {
    return state.userReferralRewardsData;
  },
  getGlobalAffiliateConfig(state) {
    return state.globalAffiliateConfig;
  },
  getGlobalConfig(state) {
    return state.globalConfig;
  },
  getWalletDialogState(state) {
    return state.walletDialog;
  },
  getSingleGameData(state) {
    return state.singlegamedata;
  },
  userprofiles(state) {
    return state.userprofiles;
  },
  safesstatus(state) {
    return state.safes;
  },
  userdeposits(state) {
    return state.userdeposits;
  },
  orderStatus(state) {
    return state.orderStatus;
  },
  getstackerevents(state) {
    return state.stackerevents;
  },
  getsystemevents(state) {
    return state.systemevents;
  },
  postdeposits(state) {
    return state.postdeposits;
  },
  getManualDeposits(state) {
    return state.manualdeposits;
  },
  getSystemData(state) {
    return state.systemdata;
  },
  getSmartSafeRates(state) {
    return state.SmartSafeRates;
  },
  getVirtualRates(state) {
    return state.VirtualRates;
  },
  getTokenMap(state) {
    return state.tokenmap;
  },
  getPrivateRoomURL(state) {
    return state.privateRoomURL;
  },
  getSystemSnap(state) {
    return state.systemsnap;
  },
  getReferralLink(state) {
    return state.referralLink;
  },
  currentuserprofile(state) {
    return state.userprofile;
  },
  currentuserwallets(state) {
    return state.currentuserwallets;
  },
  getGameplayToken(state) {
    return state.gameplayToken;
  },
  usergroups(state) {
    return state.usergroups;
  },

  loadedTokens(state) {
    return state.loadedTokens;
  },

  usersbyday(state) {
    return state.usersbyday;
  },
  getLoadedTokenProfiles(state) {
    return state.tokenprofiles;
  },
  getLoadedTokenSales(state) {
    return state.tokensales;
  },
  getLoadedGameRounds(state) {
    return state.gamerounds;
  },
  getPaymentCredentials(state) {
    return state.paymentCredentials;
  },
  getCurrentUserID(state) {
    return state.currentUserID;
  },

  getLoadedUserGameplay(state) {
    return state.allusergameplay;
  },
  getPrivateRoomsList(state) {
    return state.privateRooms;
  },
  getfriendData(state) {
    return state.userFriends;
  },
  getAllUserFriends(state) {
    return state.allUserFriends;
  },
  getAcceptedFriendsList(state) {
    return state.userFriendsAccepted;
  },
  getOnlineFriendsList(state) {
    return state.userFriendsOnline;
  },
  getOfflineFriendsList(state) {
    return state.userFriendsOffline;
  },
  getRejectedFriendsList(state) {
    return state.userFriendsRejected;
  },
  getSentFriendsList(state) {
    return state.userFriendsSent;
  },
  getBlockedFriendsList(state) {
    return state.userFriendsBlocked;
  },
  getReceivedFriendsList(state) {
    return state.userFriendsReceived;
  },
  getUserBlockedFromList(state) {
    return state.userBlockedFrom;
  },
  getFullGameData(state) {
    return state.fullgamedata;
  },
  getTopWins(state) {
    return state.topwins;
  },
  getTopLoss(state) {
    return state.toploss;
  },
  getTopBets(state) {
    return state.topbets;
  },
  getUserGameData(state) {
    return state.usergamedata;
  },
  getcurrentchallenge(state) {
    return state.acceptedchallenge;
  },
  alerts(state) {
    const list = state.alerts || [];
    return list.filter((item) => !item.message?.toLowerCase().includes('daily bonus'));
  },
  challenges(state) {
    return state.challenges;
  },
  unseenChallenges(state) {
    return state.unseenChallenges;
  },
  depositusers(state) {
    return state.depositusers;
  },
  getwalletusers(state) {
    return state.loadedwalletusers;
  },
  getloading(state) {
    return state.isloading;
  },
  isMobileResolution(state) {
    return state.isMobileResolution;
  },
  getloadingTokens(state) {
    return state.isloadingtokens;
  },
  getUserpurchases(state) {
    return state.userpurchases;
  },
  getUserwithdraws(state) {
    return state.userwithdraws;
  },
  getUserTotalWithdrawalRequests(state) {
    return state.totalUserWithdrawalRequests;
  },
  getPromotionDetails(state) {
    return state.promotionDetails;
  },
  getSignuptemplate(state) {
    return state.signuptemplate;
  },
  getInactivetemplate(state) {
    return state.inactivetemplate;
  },
  getPlayerlosstemplate(state) {
    return state.playerlosstemplate;
  },
  getPromolossamount(state) {
    return state.promolossamount;
  },
  getPlayerbettemplate(state) {
    return state.playerbettemplate;
  },
  getPromodaysinactive(state) {
    return state.promodaysinactive;
  },
  getDeposittemplate(state) {
    return state.deposittemplate;
  },
  getWithdrawaltemplate(state) {
    return state.withdrawaltemplate;
  },
  getWithdrawalReservations(state) {
    return state.withdrawalReservations;
  },
  getUserWithdrawals(state) {
    return state.userWithdrawals;
  },
  getPurchasetemplate(state) {
    return state.purchasetemplate;
  },
  uniqueusers(state) {
    return state.totaluniqueusers;
  },

  userdisplayname(state) {
    return state.userdisplay;
  },

  user(state) {
    return state.user;
  },
  loading(state) {
    return state.loading;
  },
  error(state) {
    return state.error;
  },
  getErrors(state) {
    return state.error;
  },
  getDepositMethods(state) {
    return state.depositMethods;
  },
  getRequestInvoice(state) {
    return state.invoiceData;
  },
  getRequestWithdrawal(state) {
    return state.withdrawalData;
  },
  getUserDepositBalance(state) {
    return state.depositBalance;
  },
  // getUserBonusBalance(state) {
  //   return state.bonusBalance;
  // },
  getUserWithdrawableBalance(state) {
    return state.withdrawableBalance;
  },
  getUserTotalBalance(state) {
    return state.totalBalance;
  },
  getFormattedBalance: (state) => ({
    mmc: `$${formatBalance(state.totalBalance?.balance?.MMC)}`,
    mqc: formatBalance(state.totalBalance?.balance?.MQC),
  }),
  getPlayerMode(state) {
    return state.playermode;
  },
  profilecomplete() {
    return false;
  },
  getTransHistory(state) {
    return state.transHistory;
  },
  // getBonusHistory(state) {
  //   return state.bonusHistory;
  // },
  getPackages(state) {
    return state.packages;
  },
  getPromoPackages(state) {
    const packages = typeof state.packages === 'object' ? Object.values(state.packages) : [];

    // TODO: we need to move these titles and descriptions to the BE side
    const POPUP_PACK_ID = '-NMPFhfuquBCeoLodKtw';

    return packages
      .filter((p) => p.active && p.group === 'Promo')
      .map((p) => ({
        highlighted: p.key === POPUP_PACK_ID,
        price: p.price,
        mmcAmount: p.MMC,
        mqcAmount: p.MQC,
        image: `/images/banners/promo-pack-${p.price}-${p.MMC}.webp?v=10`,
        label: p.key === POPUP_PACK_ID ? '$10 Cyber Monday Pack' : `The ${p.label} Pack`,
      }));
  },
  getPlayerInfo(state) {
    return state.playerInfo;
  },
  getGameHistory(state) {
    return state.gameHistory;
  },
  getPrivateRoomID(state) {
    return state.privateRoomID;
  },
  getLastPlayedWith(state) {
    return state.lastPlayedWith;
  },
  getOnlineUsersFromList(state) {
    return state.onlineUsersFromList;
  },
  getHomeUrl(state) {
    return state.homeUrl;
  },
  getSumsubAccessToken(state) {
    return state.sumsubAccessToken;
  },
  checkStringInArray: (state) => (routeName) => {
    return state.includedRoutes.includes(routeName);
  },
  getPossibleFriends(state) {
    return state.possibleFriends;
  },
  getUserRakeback(state) {
    return state.rakeback;
  },
  // getAvailableBonuses(state) {
  //   return state.availableBonuses;
  // },
  // getAllActiveBonuses(state) {
  //   return state.allActiveBonuses;
  // },
  // getUnclaimedBonuses(state) {
  //   return state.unclaimedBonuses;
  // },
  getGamesList(state) {
    return state.gamesList;
  },

  isUserSuspended(state) {
    const status = state.playerInfo?.profile?.accountStatus;
    const suspended = status === 'suspended' || state.user?.suspended || state.userSuspended;
    return Boolean(suspended);
  },

  isUserBanned(state) {
    return state.playerInfo?.profile?.accountStatus === 'Disabled';
  },

  getUserBoughtPackages(state) {
    return state.boughtPackages || {};
  },

  getActiveGames(state) {
    return state.activeGames;
  },

  isQCMode(state) {
    return state.playermode === state.currencies.MQC;
  },

  getGameById: (state) => (id) => state.activeGames.find((game) => `${game.ID}` === `${id}`),

  getFormattedBoughtPackages(state) {
    const boughtPackages = state.boughtPackages || {};
    return Object.entries(boughtPackages)
      .flatMap((item) => item[1])
      .flatMap((item) => Object.values(item));
  },

  /**
   * @function getPurchasedPromoPacks
   * @description Get the promo packages a user has purchased.
   * @param {Object} state The Vuex state.
   * @param {Object} getters The Vuex getters.
   * @returns {Array} ['MMC-MQC'] The MMC-MQC of The promo packages purchased.
   */
  getPurchasedPromoPacks(state, getters) {
    const boughtPackages = getters.getFormattedBoughtPackages.map((item) => `${item.creditedMMC}-${item.creditedMQC}`);
    const promoPackages = Object.values(state.packages || {})
      .filter((item) => item.group === 'Promo')
      .map((item) => `${item.MMC}-${item.MQC}`);

    if (!boughtPackages.length || !promoPackages.length) return [];
    return boughtPackages.filter((item) => promoPackages.includes(item));
  },

  hasPromoPurchased(state, getters) {
    const boughtPackages = getters.getFormattedBoughtPackages;
    const promoPackages = Object.values(state.packages || {}).filter((item) => item.group === 'Promo');
    let hasPromoPurchased = false;

    if (boughtPackages.length) {
      hasPromoPurchased = boughtPackages.some((item) => {
        return !!promoPackages.find((p) => p.MMC === item.creditedMMC && p.MQC === item.creditedMQC);
      });
    }

    return hasPromoPurchased;
  },

  getActivePromoPack(state, getters) {
    const hasLimitOfPurchases = false;
    const packToPromote = `1100-10000000`; // MMC-MQC
    const packData = getters.getPromoPackages.find((item) => `${item.mmcAmount}-${item.mqcAmount}` === packToPromote);
    const isPackAvailable = hasLimitOfPurchases ? !getters.getPurchasedPromoPacks.includes(packToPromote) : true;

    if (packData && isPackAvailable) return packData;
    return null;
  },

  isKycApproved(state, getters) {
    const user = getters.getPlayerInfo?.profile;
    const userKycCompleted = user?.kycStatus === 'completed';
    const userKycGreen = user?.kyc?.result === 'GREEN';
    return userKycCompleted && userKycGreen;
  },

  isWelcomeOldUser(state) {
    if (!state.playerInfo) return false;
    const regDate = new Date(state.playerInfo.profile.createdAt);
    const oldDate = new Date(WELCOME_OFFER_RELEASE_DATE);
    return regDate.getTime() < oldDate.getTime();
  },
};
